module.exports = "<h2>Important Syntax Changes</h2>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/04-syntax/00.pug
// module id = 322
// module chunks = 1